import { Row, Col } from "react-bootstrap"
import { Card, ListGroup } from "react-bootstrap"
import LableValueDisplay from "./LableValueDisplay"
import Tinymce from '../../components/Form/editors/Tinymce';

const CarePlanAttribute = ({AttributeData}) => {
  
  return (
    <>
    <Row>
    <div className="col-md-12">
        <Card>
            <Card.Header>Care Plan</Card.Header>
            <ListGroup variant="flush">
            {/* <Tinymce toolbar={false} initialValue={AttributeData.carePlanProfile}/> */}
            <textarea rows={4} defaultValue={AttributeData.carePlanProfile} />
             </ListGroup> 

            <Card.Header>Data</Card.Header>
            <ListGroup variant="flush">
                {AttributeData.customerCarePlanAttributes.map(med=>(
                <>
                <ListGroup.Item key={med.id}>            
                  <LableValueDisplay name={med.planAttributeName} value={med.planAttributeValue} />
                </ListGroup.Item>
                </> 
                ))}
            </ListGroup>
        </Card>
    </div>
    </Row>
    </>
  )
}


export default CarePlanAttribute